import React from 'react';
import StatusChip from './ui/StatusChip';

/*
 * Compat: mantém a API antiga (<StatusBadge status size>) redirecionando para o
 * StatusChip sem emoji. Migração completa no P4 remove este wrapper.
 */
const SIZE_MAP = { small: 'sm', normal: 'md', large: 'md' };

const StatusBadge = ({ status, size = 'normal' }) => (
  <StatusChip status={status} size={SIZE_MAP[size] || 'md'} />
);

export default StatusBadge;
